import React from 'react';
import { BuildingIcon, SearchIcon, UsersIcon, CpuIcon, CheckCircleIcon } from 'lucide-react';
export function PricingValue() {
  return <section className="py-24 bg-slate-50" data-id="element-4087">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4088">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4089">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4090">
            Simple <span className="text-blue-600" data-id="element-4091">local business API</span>{' '}
            pricing
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-4092">
            Pay only for successful results. All accounts start with free
            credits to test before scaling.
          </p>
        </div>

        {/* Pricing Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-4093">
          {/* Search Card — Free, lead with this */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-4094">
            <div className="flex items-center gap-3 mb-4" data-id="element-4095">
              <SearchIcon className="w-5 h-5 text-slate-400" data-id="element-4096" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-4097">Search</h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-4098">
              Find companies that match your filters
            </p>
            <div data-id="element-4099">
              <div className="flex items-baseline gap-2" data-id="element-4100">
                <span className="text-4xl font-bold text-slate-900" data-id="element-4101">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-4102">unlimited searches</p>
            </div>
          </div>

          {/* Find People Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-4103">
            <div className="flex items-center gap-3 mb-4" data-id="element-4104">
              <UsersIcon className="w-5 h-5 text-slate-400" data-id="element-4105" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-4106">Find people</h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-4107">
              Find decision-makers with verified contact info
            </p>
            <div className="space-y-4" data-id="element-4108">
              <div data-id="element-4109">
                <div className="flex items-baseline gap-2" data-id="element-4110">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-4111">
                    from $3
                  </span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-4112">
                  per 100 contacts found
                </p>
              </div>
              <div className="grid grid-cols-3 gap-3 pt-4 border-t border-slate-100" data-id="element-4113">
                <div data-id="element-4114">
                  <div className="text-lg font-bold text-slate-900" data-id="element-4115">$3</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-4116">per 100 names</p>
                </div>
                <div data-id="element-4117">
                  <div className="text-lg font-bold text-slate-900" data-id="element-4118">$6</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-4119">per 100 emails</p>
                </div>
                <div data-id="element-4120">
                  <div className="text-lg font-bold text-slate-900" data-id="element-4121">$24</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-4122">per 100 phones</p>
                </div>
              </div>
            </div>
          </div>

          {/* Enrich Technographics Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-4123">
            <div className="flex items-center gap-3 mb-4" data-id="element-4124">
              <CpuIcon className="w-5 h-5 text-slate-400" data-id="element-4125" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-4126">
                Enrich technographics
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-4127">
              Get what technologies a company uses
            </p>
            <div data-id="element-4128">
              <div className="flex items-baseline gap-2" data-id="element-4129">
                <span className="text-4xl font-bold text-slate-900" data-id="element-4130">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-4131">
                per 100 records enriched
              </p>
            </div>
          </div>

          {/* Export Leads Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-4132">
            <div className="flex items-center gap-3 mb-4" data-id="element-4133">
              <BuildingIcon className="w-5 h-5 text-slate-400" data-id="element-4134" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-4135">Export leads</h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-4136">
              Export enriched leads with employee count, hiring signals, and
              more
            </p>
            <div data-id="element-4137">
              <div className="flex items-baseline gap-2" data-id="element-4138">
                <span className="text-4xl font-bold text-slate-900" data-id="element-4139">$0.15</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-4140">
                per 100 records exported
              </p>
            </div>
          </div>
        </div>

        {/* Trust Signals */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-4141">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-4142">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-4143" />
            <span data-id="element-4144">Pay only for results</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-4145">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-4146" />
            <span data-id="element-4147">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-4148">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-4149" />
            <span data-id="element-4150">Usage dashboard included</span>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-4151">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-4152">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-4153">
              Try for free
            </a>
            <a href="https://api.openmart.ai/redoc" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-slate-700 font-medium bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors text-lg" data-id="element-4154">
              Read the docs
            </a>
          </div>
          <p className="text-sm text-slate-500 font-medium" data-id="element-4155">
            No credit card required
          </p>
        </div>
      </div>
    </section>;
}